import { menuClasses, MenuItemStyles } from 'react-pro-sidebar';
import colors from '@/mui/colors';

export const menuItemStyles: MenuItemStyles = {
  root: {
    fontSize: '14px',
    fontWeight: 400,
    color: colors.text,
  },

  icon: {
    color: 'inherit',
    [`&.${menuClasses.open}`]: {
      fontWeight: 500,
    },
    [`&.${menuClasses.active}`]: {
      fontWeight: 500,
    },
  },

  // #root > div.MuiStack-root.overflow-hidden.bg-gray-950.pb-16.css-nen11g-MuiStack-root > div.MuiStack-root.css-m69qwo-MuiStack-root > div > div.MuiStack-root.h-full.w-full.css-m69qwo-MuiStack-root > div._sidebar_5r7mw_20 > aside > div > div > div.h-\[calc\(100\%-128px\)\] > nav > ul > li.ps-menuitem-root.ps-active.css-1yaeyj8 > a > span.ps-menu-label.ps-active.css-178fwf2

  button: {
    paddingLeft: '16px',
    paddingRight: '16px',
    height: '44px',
    borderRadius: '0px',
    transition: 'all 0.2s',
    [`&.${menuClasses.open}`]: {
      color: '#fff',
    },
    [`& span.ps-menu-label`]: {
      padding: '0 0 0 12px', 
      fontWeight: 500,
    },
    [`&.${menuClasses.active}`]: {
      backgroundColor: 'rgba(59, 130, 246, 0.1)', // Blue-500 with opacity
      color: '#60a5fa', // Blue-400
      borderRight: '3px solid #3b82f6', // Blue-500
    },
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.03)',
      color: '#fff',
    },
  },

  label: {
    color: 'inherit',
    [`&.${menuClasses.open}`]: {
      fontWeight: 500,
    },
    [`&.${menuClasses.active}`]: {
      fontWeight: 500,
    },
  },

  subMenuContent: {
    paddingLeft: '12px',
    background:
      'linear-gradient(0deg, rgba(255, 255, 255, 0.03) 0%, rgba(255, 255, 255, 0.03) 100%), #0A0E15',
  },

  SubMenuExpandIcon: {
    color: 'inherit',
    [`&.${menuClasses.open}`]: {
      fontWeight: 500,
    },
    [`&.${menuClasses.active}`]: {
      fontWeight: 500,
    },
  },
};
